import React, { useState, useEffect } from 'react';

// The modal now accepts 'initialData' to pre-fill the form for editing.
export default function VendorModal({ isOpen, onClose, onSave, initialData = null }) {
    const [englishName, setEnglishName] = useState('');
    const [arabicName, setArabicName] = useState('');

    // This effect pre-fills the form when the modal opens in "Edit" mode.
    useEffect(() => {
        if (isOpen) {
            if (initialData) {
                setEnglishName(initialData.english_name || '');
                setArabicName(initialData.arabic_name || '');
            } else {
                // Explicitly clear fields for "Add" mode
                setEnglishName('');
                setArabicName('');
            }
        }
    }, [initialData, isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onSave({ english_name: englishName, arabic_name: arabicName });
            onClose(); // Close modal only after a successful save
        } catch (error) {
            console.error("Failed to save vendor:", error);
            // The error message will be displayed on the main page.
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6">{initialData ? 'Edit Vendor' : 'Add New Vendor'}</h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700 font-medium mb-2">English Name</label>
                        <input type="text" value={englishName} onChange={(e) => setEnglishName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 font-medium mb-2">Arabic Name</label>
                        <input type="text" value={arabicName} onChange={(e) => setArabicName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div className="flex justify-end gap-4">
                        <button type="button" onClick={onClose} className="bg-gray-300 text-gray-800 font-bold py-2 px-6 rounded-lg hover:bg-gray-400">
                            Cancel
                        </button>
                        <button type="submit" className="bg-blue-600 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-700">
                            Save Vendor
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}